// extracted by mini-css-extract-plugin
export default {"headings":"c5ba174ff5e4"};